import { styled as s, Button as i } from "@mui/material";
import u from "../next/Image.js";
import { DEFAULT_ANIMATE_DURATION as h } from "../../../constants/layout.js";
import { noForwardProps as l } from "../../../util/styled/index.js";
import * as o from "ramda";
import { jsx as r } from "react/jsx-runtime";
const I = s(i, l)`
  min-width: unset;
  padding: unset;
  transition: ${h}ms;
  ${(t) => t.__hover && `
      :hover {
        transform: scale(1.05);
        filter: brightness(1.2);
      }
    `}
`, f = s(u)`
  height: 100%;
  width: 100%;
`, v = (t) => {
  const {
    className: n,
    hover: m = !0,
    onClick: e
  } = t, c = o.has("customIcon", t) ? t.customIcon : null, a = o.has("src", t) ? t.src : null;
  return /* @__PURE__ */ r(I, {
    __hover: m,
    className: n,
    onClick: e,
    children: c || /* @__PURE__ */ r(f, {
      className: "Custom-Image",
      src: a
    })
  });
};
export {
  v as default
};
//# sourceMappingURL=ApeironImageButton.js.map
